module.exports = __webpack_public_path__ + "static/wilde-ganzen-7e94e0d72e59a6d81dc5a08956d1c2eb.png";